export const HOPLA_URL = 'https://www.hoplacoaching.fr/api';
export const COOKIE_DOMAIN = 'hoplacoaching.fr';

//export const HOPLA_URL = 'https://localhost:1235/api';
//export const COOKIE_DOMAIN = ''